import { memo } from 'react'
import MediaUploadButton from 'components/MediaUploadButton'
import AddVoiceFile from './AddVoiceFile'
import VoiceCard, { VoiceCardUploading } from './VoiceCard'
import ConsentPopup from './ConsentPopup'
import UploadFailedPopup from './UploadFailedPopup'
import { useVoiceClone } from './useVoiceClone'

const VoiceCloneTab: React.FC = () => {
  const {
    clonedVoice,
    uploadStatus,
    uploadTriggerRef,
    isConsentOpen,
    handleFilesUpload,
    onConsentConfirm,
    onConsentCancel,
    onUploadClick,
    onMyVoicesClick,
    onRemoveVoice,
    onTryAgain,
    onFailedPopupClose
  } = useVoiceClone()

  return (
    <>
      <MediaUploadButton
        acceptType="audio"
        handleFilesUpload={handleFilesUpload}
        refTrigger={uploadTriggerRef}
      />

      {uploadStatus === 'uploading' ? (
        <VoiceCardUploading />
      ) : clonedVoice ? (
        <VoiceCard
          name={clonedVoice.name}
          url={clonedVoice.url}
          onRemove={onRemoveVoice}
        />
      ) : (
        <AddVoiceFile
          onUploadClick={onUploadClick}
          onMyVoicesClick={onMyVoicesClick}
          onFilesDropped={handleFilesUpload}
        />
      )}

      <ConsentPopup
        isOpen={isConsentOpen}
        onConfirm={onConsentConfirm}
        onCancel={onConsentCancel}
      />

      <UploadFailedPopup
        isOpen={uploadStatus === 'failed'}
        onTryAgain={onTryAgain}
        onClose={onFailedPopupClose}
      />
    </>
  )
}

export default memo(VoiceCloneTab)
